import './App.css';
import LandingPage from './pages/LandingPage';
import {
  BrowserRouter,
  Link,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Receipt from './pages/Receipt';
import TermAndCond from './pages/term&Cond/Term&Cond';
// import AboutUs from './pages/AboutUs/AboutUs';
// import Traning from './pages/Traning/Traning';
import Contact from './pages/Contact/Contact';
import RefundPolicy from './pages/RefundPolicy/RefundPolicy';
import { useEffect, useState } from 'react';
import DashBoard from './pages/dashBoard/DashBoard';
import Enroll from './pages/auth/Enroll';
import { useDispatch, useSelector } from 'react-redux';
import { getFacebookFbc, getFacebookFbp } from './redux/features/fb/fbSlice';

function App() {
  const isLogin = useSelector(state => state.login?.isLogin)
  const isEnroll = useSelector(state => state.enroll?.isEnroll)
  const dispatch = useDispatch()


  
  useEffect(() => {
    
    dispatch(getFacebookFbp(0))
    dispatch(getFacebookFbc(0))
    
    
  }, []);

  const CheckPayment = ({children})=>{
    if(isEnroll){
      return children
    }else{
      return <Navigate to={"/"} />
    }
  }
  const CheckLogin = ({children})=>{
    
    if(isLogin){
      return children
    }else{
      return <Navigate to={"/"} />
    }
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<LandingPage />} />
        <Route exact path='/receipt' element={isLogin? <Receipt />: <Navigate to={"/"} />} />
        <Route exact path='/termandcond' element={<TermAndCond />} />
        {/* <Route exact path='/about' element={<AboutUs />} />
        <Route exact path='/traing' element={<Traning />} /> */}
        <Route exact path='/contact' element={<Contact />} />
        <Route exact path='/refundpolicy' element={<RefundPolicy />} />
        <Route exact path='/dashboard' element={isLogin? <DashBoard />: <Navigate to={"/"} />} />
        <Route exact path='/enroll' element={isEnroll? <Enroll />: <Navigate to={"/"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
